import { z } from 'zod'
import ClientLogger from '@eversports/react-components/utilities/client-logger'
import { ClientMetadataPlatform } from '../typings/ClientMetadata'

const CLIENT_METADATA_STORAGE_KEY = 'clientMetadata'

const ClientMetadataSchema = z.object({
  isBrandedApp: z.coerce.boolean().optional(),
  platform: z.nativeEnum(ClientMetadataPlatform).optional(),
})

export function getClientMetadata() {
  if (typeof window === 'undefined') return null

  const data = window.sessionStorage.getItem(CLIENT_METADATA_STORAGE_KEY)

  if (!data) {
    return null
  }

  try {
    return ClientMetadataSchema.parse(JSON.parse(data))
  } catch (error) {
    if (error instanceof z.ZodError) {
      ClientLogger.error('Failed to parse client metadata', {
        issues: error.issues,
        data,
      })
    } else {
      ClientLogger.error('Error parsing client metadata', { error, data })
    }
    return null
  }
}
